import React from 'react'
import { AppContext } from 'contexts/AppContext'

export default class AppComponent extends React.Component {}
AppComponent.contextType =  AppContext;